import React, { useState, useRef } from "react";
import "./LabourRec.css"

const LabourRec = () => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [labourData, setLabourData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [message, setMessage] = useState("");

  // CAMERA STATES
  const [cameraOpen, setCameraOpen] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  // ---------- OPEN CAMERA ----------
  const openCamera = async () => {
    try {
      setCameraOpen(true);

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" }, // back camera on phone
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (err) {
      alert("Camera access denied or unavailable");
      console.error(err);
    }
  };

  // ---------- CAPTURE PHOTO ----------
  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      const file = new File([blob], "capture.jpg", { type: "image/jpeg" });

      setImage(file);
      setPreview(URL.createObjectURL(blob));

      // Stop camera
      const stream = video.srcObject;
      stream.getTracks().forEach((t) => t.stop());
      setCameraOpen(false);
    });
  };

  // ---------- UPLOAD HANDLER ----------
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  // ---------- FACE RECOGNITION ----------
  const recognizeFace = async () => {
    if (!image) {
      alert("Please upload or capture an image");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("image", image);

      const response = await fetch(
        "https://jkumarapi.axiomos.in/labour/recognize",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.match && data.labour) {
        setLabourData(data.labour);
        setModalOpen(true);
      } else {
        setMessage(
          `❌ No match found. Similarity: ${data.similarity?.toFixed(3)}`
        );
      }
    } catch (error) {
      console.error("Recognition error:", error);
      setMessage("Server error during recognition.");
    } finally {
      setLoading(false);
    }
  };

  // ---------- REUSABLE SECTION ----------
  const Section = ({ title, children }) => (
    <div className="section-card">
      <h4>{title}</h4>
      {children}
    </div>
  );

  return (
    <div className="lr-container">
      <h2 className="lr-title">Labour Face Recognition</h2>

      {/* CAMERA PREVIEW */}
      {cameraOpen && (
        <div className="lr-camera-box">
          <video ref={videoRef} className="lr-video"></video>

          <button className="lr-btn-capture" onClick={capturePhoto}>
            📸 Capture Photo
          </button>
        </div>
      )}

      {/* IMAGE PICKER */}
      {!cameraOpen && (
        <>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="lr-file"
          />

          <button className="lr-btn-secondary" onClick={openCamera}>
            Open Live Camera
          </button>
        </>
      )}

      {/* PREVIEW */}
      {preview && <img src={preview} alt="preview" className="lr-preview" />}

      {/* IDENTIFY BUTTON */}
      <button
        onClick={recognizeFace}
        disabled={loading}
        className="lr-btn-primary"
      >
        {loading ? "Recognizing..." : "Identify Labour"}
      </button>

      {message && <p className="lr-message-error">{message}</p>}

      {/* CANVAS */}
      <canvas ref={canvasRef} className="lr-hidden"></canvas>

      {/* FULL DETAILS MODAL */}
      {modalOpen && labourData && (
        <div className="lr-modal-overlay">
          <div className="lr-modal">
            <button
              className="lr-modal-close"
              onClick={() => setModalOpen(false)}
            >
              ✖
            </button>

            <h3 className="lr-modal-title">Labour Full Details</h3>

            {labourData.photoUrl && (
              <img
                src={labourData.photoUrl}
                alt="labour"
                className="lr-modal-photo"
              />
            )}

            {/* Basic Info */}
            <Section title="Basic Information">
              <p>
                <b>Name:</b> {labourData.name}
              </p>
              <p>
                <b>Phone:</b> {labourData.phone}
              </p>
              <p>
                <b>Aadhaar:</b> {labourData.aadhaarNumber}
              </p>
              <p>
                <b>Status:</b> {labourData.status}
              </p>
              <p>
                <b>Experience:</b> {labourData.experienceInYears} years
              </p>
            </Section>

            {/* Project */}
            {labourData.project && (
              <Section title="Project">
                <p>
                  <b>Project:</b> {labourData.project.projectName}
                </p>
                <p>
                  <b>Location:</b> {labourData.project.siteLocation}
                </p>
              </Section>
            )}

            <button
              className="lr-btn-primary mt-2"
              onClick={() => setModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LabourRec;
